module.exports = __webpack_public_path__ + "static/malediven-f268221b4009c0fbf919d7e941012c31.svg";